export class TipoConector {
  Nombre: string;
  Descripcion: string;
  Version: number | null;
  TodosUsuarios: boolean;
  Activo: boolean;

  constructor() {
    this.Nombre = "";
    this.Descripcion = "";
    this.Version = null;
    this.TodosUsuarios = false;
    this.Activo = false;
  }
}
